import store from '~/js/store'
export default class Dropdown {
  constructor(id) {
    this.id = id
    this.el = document.querySelector(`.js-${this.id}-dropdown`)
    this.items = document.querySelectorAll(`.js-${this.id}-dropdown-item`)
    this.currentItem = document.querySelector(`.js-${this.id}-dropdown-current`)
    this.activeItem = null
    this.currentItemClickHandler = this.currentItemClickHandler.bind(this)
    this.itemClickHandler = this.itemClickHandler.bind(this)
    this.documentClickHandler = this.documentClickHandler.bind(this)
    this.documentKeyupHandler = this.documentKeyupHandler.bind(this)

    this.init()
  }

  open() {
    if (this.el) {
      this.el.classList.add(`opened`)

      if (this.items.length) {
        this.items.forEach(item => {
          item.tabIndex = 0
          item.addEventListener(`click`, this.itemClickHandler)
        })
      }

      document.addEventListener(`click`, this.documentClickHandler, true)
      document.addEventListener(`keyup`, this.documentKeyupHandler)
    }
  }

  close() {
    if (this.el) {
      this.el.classList.remove(`opened`)

      if (this.items.length) {
        this.items.forEach(item => {
          item.tabIndex = `-1`
          item.removeEventListener(`click`, this.itemClickHandler)
        })
      }

      document.removeEventListener(`click`, this.documentClickHandler, true)
      document.removeEventListener(`keyup`, this.documentKeyupHandler)
    }
  }

  currentItemClickHandler(e) {
    e.stopPropagation()
    this.open()

  }
  itemClickHandler(e) {
    this.activeItem = this.el.querySelector(`.js-${this.id}-dropdown-item.active`);
    if(e.target.classList.contains('js-location-dropdown-item')){
      store.commit('location_change', e.target.dataset.name);
    }
    if (this.activeItem) {
      this.activeItem.classList.remove(`active`)
    }
    this.activeItem = e.currentTarget
    this.activeItem.classList.add(`active`)
    this.currentItem.childNodes[0].textContent = this.activeItem.textContent
    this.close()

    var event = new CustomEvent('select-change', {'detail': e.target.dataset});
    document.dispatchEvent(event);
  }

  documentClickHandler(e) {
    if (!e.target.closest(`.js-${this.id}-dropdown-item`)) {
      this.close()
    }
  }

  documentKeyupHandler(e) {
    if (e.key === `Escape`) {
      this.close()
    }
  }

  bind() {
    if (this.currentItem) {
      this.currentItem.addEventListener(`click`, this.currentItemClickHandler)
    }
  }

  init() {
    this.bind()
  }

  reset() {
    this.close()
    this.currentItem.childNodes[0].textContent = `Не выбрано`

    if (this.activeItem) {
      this.activeItem.classList.remove(`active`)
      this.activeItem = null
    }
  }
}
